import React from 'react';
import Button from '../Button';
import { Link } from '@inertiajs/inertia-react';
import Swal from 'sweetalert2';
import { Inertia } from '@inertiajs/inertia';

const CouponCard = ({ id, name, code, percent, limit, orders, office }) => {

    const handleDelete = () => {
        Swal.fire({
            icon: 'warning',
            title: '¿Estás seguro de querer eliminar este cupón de descuento?',
            text: 'Las órdenes que ya cobraron este cupón aún seguirán aplicados, pero ya no podrá utilizarse este cupón.',
            buttonsStyling: false,
			showCancelButton: true,
			customClass: {
				confirmButton: 'mx-1 py-2 px-4 rounded bg-red-600 text-white',
				cancelButton: 'mx-1 py-2 px-4 rounded bg-gray-500 text-white'
			},
			reverseButtons: true,
			confirmButtonText: 'Eliminar',
			cancelButtonText: 'Cancelar'
        }).then(({ isConfirmed }) => {
            if (isConfirmed) {
                Inertia.delete(route('coupons.delete', { office, coupon: id }))
            }
        })
    }

    return (
        <div className="border bg-white rounded-xl shadow mb-2 py-4 px-4 sm:flex sm:items-center sm:justify-between">
            <div className="mb-4 sm:flex sm:items-center sm:mb-0 sm:gap-4">
                <h2 className="text-center text-lg font-bold mb-4 sm:mb-0 sm:text-xl">{name}</h2>
                <h4 className="text-center font-semibold text-sm tracking-widest">{code}</h4>
            </div>
            <div className="sm:flex sm:items-center sm:gap-4">
                <div className="flex flex-col justify-center items-center mb-4 sm:mb-0">
                    <h3 className="text-3xl">{percent}%</h3>
                    <p>de descuento</p>
                </div>

                <div className="flex flex-col justify-center items-center">
                    <h3 className="text-3xl">{orders?.length || 0}/{limit}</h3>
                    <p>cupones usados</p>
                </div>
            </div>
            <div className="flex items-center gap-2">
                <Link href={route('coupons.edit', { office, coupon: id })}>
                    <Button type="button">Editar</Button>
                </Link>
                <Button className="bg-red-500 text-white" type="button" onClick={handleDelete}>Eliminar</Button>
            </div>
        </div>
    )
}

export default CouponCard;